module.exports = __webpack_public_path__ + "static/media/007.25be100c.jpg";